import get from 'lodash/get'
import map from 'lodash/map'
import find from 'lodash/find'
import filter from 'lodash/filter'
import reject from 'lodash/reject'

//燃料类型列表
let fuelTypeList = [
  {
    label: '全部车辆',
    value: 1,
    code: ''
  },
  {
    label: '柴油车辆',
    value: 2,
    code: '0'
  },
  {
    label: 'LNG车辆',
    value: 3,
    code: '1'
  },
  {
    label: '新能源车辆',
    value: 4,
    code: '2'
  }
]
export let tempArr = [
  '第1-3名',
  '第4-7名',
  '第8-12名',
  '第13-18名',
  '第19-31名'
]
export let getFuelTypeList = function() {
  return fuelTypeList
}
export let getFuelTypeCode = function(value) {
  let item = find(fuelTypeList, ['value', value])
  return get(item, 'code', '')
}

//加油站品牌列表
let gasStationBrandList = [
  {
    label: '所有油站',
    brand: '所有油站',
    value: 0
  },
  {
    label: '中国石化',
    brand: 'S级油站',
    value: 2
  },
  {
    label: '中国石油',
    brand: 'C级油站',
    value: 1
  },
  {
    label: '其他油站',
    brand: 'E级油站',
    value: 3
  }
]
export let getGasStationDropBox = function() {
  return map(gasStationBrandList, it => {
    return {
      name: it.brand,
      code: it.value
    }
  })
}
export let getGasStationArray = function() {
  return map(gasStationBrandList, 'brand')
}
export let getBaseGasStationArray = function() {
  let tmp = reject(gasStationBrandList, ['value', 0])
  return map(tmp, 'brand')
}
export let getGasStationLabelByBrand = function(text) {
  let item = find(gasStationBrandList, ['brand', text])
  return get(item, 'label', '')
}
export let getGasStationTypeByBrand = function(text) {
  let item = find(gasStationBrandList, ['brand', text])
  return get(item, 'value', 0)
}
